export enum DirectionTypes {
  IncomingAndOutgoing = 'Incoming and Outgoing',
  Incoming = 'Incoming',
  Outgoing = 'Outgoing',
}
